import { IGifService } from "../../domain";
import { GifDto } from "../http";

// TODO: Move to a global config
const RANDOM_GIFS: GifDto[] = [
  {
    alt: "Abuela soplando las velas de su 102 cumpleaños y sucede algo inesperado...",
    src: "https://media.giphy.com/media/l4KibWpBGWchSqCRy/giphy.gif",
  },
  {
    alt: "Niño obturado en el retrete",
    src: "https://media.giphy.com/media/3ohs4qw8hkPShGeanS/giphy.gif",
  },
  {
    alt: "Mujer abriendo una botella de Coca-Cola previamente agitada... ¿qué sucederá?",
    src: "https://media.giphy.com/media/hQKiGV6MG8WmsHg2yx/giphy.gif",
  },
  {
    alt: "Niño sentado en una silla de playa en la orilla del mar. Justo viene una ola y... ¡splash!",
    src: "https://media.giphy.com/media/cS83sLRzgVOeY/giphy.gif",
  },
];

export class GifService implements IGifService {
  execute = async () => {
    const random = Math.floor(
      Math.random() * (RANDOM_GIFS.length - 1 - 0 + 1) + 0
    );

    const Gif = RANDOM_GIFS[random];
    return Gif;
  };
}
